import React from "react";

const DanceFloorRidgleyOutline = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="302.252"
      height="291.432"
      fillRule="nonzero"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      clipRule="evenodd"
      version="1.1"
      viewBox="0 0 302.252 291.432"
      xmlSpace="preserve"
      className="clickable"
    >
      <g
        fill="none"
        stroke="#ff5c97"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="5"
        transform="translate(-2386.74 -252.899)"
      >
        <path
          className="object-glow"
          fill="rgba(0,0,0,0)"
          d="M2482.02 255.467c-14.11.784-30.14 3.796-35.31 6.043-5.02 2.184-45.85 25.172-48.88 31.24-3.96 7.915-4.2 28.509.33 32.813 4.5 4.27 17.93 4.633 36.75 5.731 11.36.662 23.85.893 23.85.893l.54 21.469s-58.83-2.307-66.08 9.776c-4.38 7.305-5.41 121.024-1.75 165.378 1.03 12.449 15.09 12.426 23.84 12.582 67.16 1.199 182.78.188 243.8-6.288 11.04-1.171 17.92-10.029 18.37-13.559 2.93-23.25 1.7-106.593 2.37-145.454.12-6.866-.38-13.729-2.56-15.64-7-6.114-58.88-5.01-58.88-5.01l.1-24.479s56.92-21.493 62.09-26.568c5.44-5.33 5.83-12.381 5.86-19.387.03-6.463.01-12.966-2.57-16.236-5.64-7.137-187.76-14.088-201.87-13.304z"
          opacity="1"
        ></path>
        <path
          className="object-glow"
          fill="rgba(0,0,0,0)"
          d="M2480.76 342.673v10.222H2511c20.16 0 39.67.192 58.51.578l28.27.579c-.07-3.536-.15-7.072-.22-10.608-.07-3.536-.15-7.072-.22-10.607l-13.15.578c-8.76.386-18.7.579-29.8.579-11.1 0-26.15-.257-45.14-.772l-28.49-.771v10.222z"
          opacity="1"
        ></path>
      </g>
    </svg>
  );
}

export default DanceFloorRidgleyOutline;